import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { LayoutService } from '../../../core/layout/layout.service';
import { CONSTANTS } from '../../constants/constants';

interface NavItem {
  label: string;
  icon: string;
  route: string;
  exact?: boolean;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, ButtonModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  readonly CONSTANTS = CONSTANTS;
  private readonly layoutService = inject(LayoutService);
  private readonly router = inject(Router);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        if (this.layoutService.isMobile()) {
          this.layoutService.setSidebarOpen(false);
        }
      });
  }

  closeSidebar(): void {
    this.layoutService.setSidebarOpen(false);
  }

  navItems: NavItem[] = [
    { label: CONSTANTS.DASHBOARD_NAV_HOME, icon: 'fa-regular fa-house', route: '/dashboard', exact: true },
    { label: CONSTANTS.DASHBOARD_NAV_CLIENTS, icon: 'fa-solid fa-user-group', route: '/clients' },
    { label: CONSTANTS.DASHBOARD_NAV_LEGAL_CASES, icon: 'fa-solid fa-scale-balanced', route: '/legal-cases' },
    { label: CONSTANTS.DASHBOARD_NAV_CASES, icon: 'fa-regular fa-folder-open', route: '/cases' },
    { label: CONSTANTS.DASHBOARD_NAV_TASKS, icon: 'fa-regular fa-rectangle-list', route: '/tasks' },
    { label: CONSTANTS.DASHBOARD_NAV_FILES, icon: 'fa-regular fa-file', route: '/files' },
    { label: CONSTANTS.DASHBOARD_NAV_CALENDAR, icon: 'fa-regular fa-calendar', route: '/calendar' },
    // COMMENTED FOR BETA TESTING
    // { label: CONSTANTS.DASHBOARD_NAV_NOTES, icon: 'fa-regular fa-note-sticky', route: '/notes' },
    // { label: CONSTANTS.DASHBOARD_NAV_APPOINTMENTS, icon: 'fa-regular fa-pen-to-square', route: '/appointments' },
  ];
}
